module.exports = __webpack_public_path__ + "img/avatar.f25caf24.svg";